var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_397_6404)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 24,
    width: 154,
    height: 154,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 44H57V47.931H60.931V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 44H60.931V47.931H64.8621V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 44H64.8621V47.931H68.7931V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 44H68.7931V47.931H72.7241V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 44H72.7241V47.931H76.6552V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 44H76.6552V47.931H80.5862V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 44H80.5862V47.931H84.5172V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 44H88.4483V47.931H92.3793V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 44H92.3793V47.931H96.3103V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 44H96.3103V47.931H100.241V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 44H100.241V47.931H104.172V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 44H108.103V47.931H112.034V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 44H115.966V47.931H119.897V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 44H119.897V47.931H123.828V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 44H127.759V47.931H131.69V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 44H143.483V47.931H147.414V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 44H147.414V47.931H151.345V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 44H151.345V47.931H155.276V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 44H155.276V47.931H159.207V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 44H159.207V47.931H163.138V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 44H163.138V47.931H167.069V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 44H167.069V47.931H171V44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 47.931H57V51.8621H60.931V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 47.931H80.5862V51.8621H84.5172V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 47.931H96.3103V51.8621H100.241V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 47.931H108.103V51.8621H112.034V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 47.931H119.897V51.8621H123.828V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 47.931H123.828V51.8621H127.759V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 47.931H135.621V51.8621H139.552V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 47.931H143.483V51.8621H147.414V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 47.931H167.069V51.8621H171V47.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 51.8621H57V55.7931H60.931V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 51.8621H64.8621V55.7931H68.7931V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 51.8621H68.7931V55.7931H72.7241V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 51.8621H72.7241V55.7931H76.6552V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 51.8621H80.5862V55.7931H84.5172V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 51.8621H88.4483V55.7931H92.3793V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 51.8621H92.3793V55.7931H96.3103V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 51.8621H96.3103V55.7931H100.241V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 51.8621H100.241V55.7931H104.172V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 51.8621H104.172V55.7931H108.103V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 51.8621H119.897V55.7931H123.828V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 51.8621H123.828V55.7931H127.759V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 51.8621H127.759V55.7931H131.69V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 51.8621H131.69V55.7931H135.621V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 51.8621H143.483V55.7931H147.414V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 51.8621H151.345V55.7931H155.276V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 51.8621H155.276V55.7931H159.207V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 51.8621H159.207V55.7931H163.138V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 51.8621H167.069V55.7931H171V51.8621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 55.7931H57V59.7241H60.931V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 55.7931H64.8621V59.7241H68.7931V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 55.7931H68.7931V59.7241H72.7241V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 55.7931H72.7241V59.7241H76.6552V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 55.7931H80.5862V59.7241H84.5172V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 55.7931H88.4483V59.7241H92.3793V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 55.7931H96.3103V59.7241H100.241V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 55.7931H100.241V59.7241H104.172V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 55.7931H131.69V59.7241H135.621V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 55.7931H135.621V59.7241H139.552V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 55.7931H143.483V59.7241H147.414V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 55.7931H151.345V59.7241H155.276V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 55.7931H155.276V59.7241H159.207V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 55.7931H159.207V59.7241H163.138V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 55.7931H167.069V59.7241H171V55.7931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 59.7241H57V63.6552H60.931V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 59.7241H64.8621V63.6552H68.7931V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 59.7241H68.7931V63.6552H72.7241V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 59.7241H72.7241V63.6552H76.6552V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 59.7241H80.5862V63.6552H84.5172V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 59.7241H92.3793V63.6552H96.3103V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 59.7241H96.3103V63.6552H100.241V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 59.7241H100.241V63.6552H104.172V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 59.7241H104.172V63.6552H108.103V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 59.7241H112.034V63.6552H115.966V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 59.7241H115.966V63.6552H119.897V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 59.7241H143.483V63.6552H147.414V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 59.7241H151.345V63.6552H155.276V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 59.7241H155.276V63.6552H159.207V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 59.7241H159.207V63.6552H163.138V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 59.7241H167.069V63.6552H171V59.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 63.6552H57V67.5862H60.931V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 63.6552H80.5862V67.5862H84.5172V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 63.6552H88.4483V67.5862H92.3793V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 63.6552H92.3793V67.5862H96.3103V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 63.6552H96.3103V67.5862H100.241V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 63.6552H115.966V67.5862H119.897V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 63.6552H123.828V67.5862H127.759V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 63.6552H127.759V67.5862H131.69V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 63.6552H131.69V67.5862H135.621V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 63.6552H143.483V67.5862H147.414V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 63.6552H167.069V67.5862H171V63.6552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 67.5862H57V71.5172H60.931V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 67.5862H60.931V71.5172H64.8621V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 67.5862H64.8621V71.5172H68.7931V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 67.5862H68.7931V71.5172H72.7241V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 67.5862H72.7241V71.5172H76.6552V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 67.5862H76.6552V71.5172H80.5862V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 67.5862H80.5862V71.5172H84.5172V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 67.5862H88.4483V71.5172H92.3793V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 67.5862H96.3103V71.5172H100.241V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 67.5862H104.172V71.5172H108.103V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 67.5862H112.034V71.5172H115.966V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 67.5862H119.897V71.5172H123.828V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 67.5862H127.759V71.5172H131.69V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 67.5862H135.621V71.5172H139.552V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 67.5862H143.483V71.5172H147.414V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 67.5862H147.414V71.5172H151.345V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 67.5862H151.345V71.5172H155.276V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 67.5862H155.276V71.5172H159.207V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 67.5862H159.207V71.5172H163.138V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 67.5862H163.138V71.5172H167.069V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 67.5862H167.069V71.5172H171V67.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 71.5172H88.4483V75.4483H92.3793V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 71.5172H92.3793V75.4483H96.3103V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 71.5172H96.3103V75.4483H100.241V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 71.5172H104.172V75.4483H108.103V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 71.5172H108.103V75.4483H112.034V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 71.5172H112.034V75.4483H115.966V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 71.5172H115.966V75.4483H119.897V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 71.5172H119.897V75.4483H123.828V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 71.5172H123.828V75.4483H127.759V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 71.5172H131.69V75.4483H135.621V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 71.5172H135.621V75.4483H139.552V71.5172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 75.4483H57V79.3793H60.931V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 75.4483H60.931V79.3793H64.8621V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 75.4483H68.7931V79.3793H72.7241V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 75.4483H80.5862V79.3793H84.5172V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 75.4483H84.5172V79.3793H88.4483V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 75.4483H100.241V79.3793H104.172V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 75.4483H115.966V79.3793H119.897V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 75.4483H119.897V79.3793H123.828V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 75.4483H123.828V79.3793H127.759V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 75.4483H139.552V79.3793H143.483V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 75.4483H143.483V79.3793H147.414V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 75.4483H147.414V79.3793H151.345V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 75.4483H155.276V79.3793H159.207V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 75.4483H159.207V79.3793H163.138V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 75.4483H167.069V79.3793H171V75.4483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 79.3793H57V83.3103H60.931V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 79.3793H60.931V83.3103H64.8621V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 79.3793H72.7241V83.3103H76.6552V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 79.3793H76.6552V83.3103H80.5862V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 79.3793H84.5172V83.3103H88.4483V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 79.3793H96.3103V83.3103H100.241V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 79.3793H100.241V83.3103H104.172V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 79.3793H108.103V83.3103H112.034V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 79.3793H112.034V83.3103H115.966V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 79.3793H115.966V83.3103H119.897V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 79.3793H123.828V83.3103H127.759V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 79.3793H127.759V83.3103H131.69V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 79.3793H135.621V83.3103H139.552V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 79.3793H139.552V83.3103H143.483V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 79.3793H147.414V83.3103H151.345V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 79.3793H151.345V83.3103H155.276V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 79.3793H163.138V83.3103H167.069V79.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 83.3103H57V87.2414H60.931V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 83.3103H64.8621V87.2414H68.7931V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 83.3103H72.7241V87.2414H76.6552V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 83.3103H76.6552V87.2414H80.5862V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 83.3103H80.5862V87.2414H84.5172V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 83.3103H84.5172V87.2414H88.4483V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 83.3103H100.241V87.2414H104.172V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 83.3103H108.103V87.2414H112.034V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 83.3103H112.034V87.2414H115.966V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 83.3103H115.966V87.2414H119.897V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 83.3103H131.69V87.2414H135.621V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 83.3103H135.621V87.2414H139.552V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 83.3103H139.552V87.2414H143.483V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 83.3103H143.483V87.2414H147.414V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 83.3103H147.414V87.2414H151.345V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 83.3103H155.276V87.2414H159.207V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 83.3103H159.207V87.2414H163.138V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 83.3103H163.138V87.2414H167.069V83.3103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 87.2414H68.7931V91.1724H72.7241V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 87.2414H76.6552V91.1724H80.5862V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 87.2414H88.4483V91.1724H92.3793V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 87.2414H92.3793V91.1724H96.3103V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 87.2414H104.172V91.1724H108.103V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 87.2414H112.034V91.1724H115.966V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 87.2414H119.897V91.1724H123.828V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 87.2414H127.759V91.1724H131.69V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 87.2414H135.621V91.1724H139.552V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 87.2414H139.552V91.1724H143.483V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 87.2414H143.483V91.1724H147.414V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 87.2414H147.414V91.1724H151.345V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 87.2414H155.276V91.1724H159.207V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 87.2414H159.207V91.1724H163.138V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 87.2414H167.069V91.1724H171V87.2414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 91.1724H68.7931V95.1035H72.7241V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 91.1724H76.6552V95.1035H80.5862V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 91.1724H80.5862V95.1035H84.5172V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 91.1724H88.4483V95.1035H92.3793V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 91.1724H92.3793V95.1035H96.3103V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 91.1724H96.3103V95.1035H100.241V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 91.1724H100.241V95.1035H104.172V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 91.1724H104.172V95.1035H108.103V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 91.1724H108.103V95.1035H112.034V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 91.1724H112.034V95.1035H115.966V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 91.1724H119.897V95.1035H123.828V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 91.1724H127.759V95.1035H131.69V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 91.1724H135.621V95.1035H139.552V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 91.1724H155.276V95.1035H159.207V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 91.1724H159.207V95.1035H163.138V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 91.1724H163.138V95.1035H167.069V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 91.1724H167.069V95.1035H171V91.1724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 95.1035H57V99.0345H60.931V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 95.1035H60.931V99.0345H64.8621V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 95.1035H76.6552V99.0345H80.5862V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 95.1035H88.4483V99.0345H92.3793V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 95.1035H92.3793V99.0345H96.3103V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 95.1035H96.3103V99.0345H100.241V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 95.1035H112.034V99.0345H115.966V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 95.1035H127.759V99.0345H131.69V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 95.1035H131.69V99.0345H135.621V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 95.1035H135.621V99.0345H139.552V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 95.1035H147.414V99.0345H151.345V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 95.1035H163.138V99.0345H167.069V95.1035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 99.0345H57V102.966H60.931V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 99.0345H68.7931V102.966H72.7241V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 99.0345H72.7241V102.966H76.6552V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 99.0345H80.5862V102.966H84.5172V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 99.0345H92.3793V102.966H96.3103V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 99.0345H104.172V102.966H108.103V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 99.0345H108.103V102.966H112.034V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 99.0345H115.966V102.966H119.897V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 99.0345H119.897V102.966H123.828V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 99.0345H123.828V102.966H127.759V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 99.0345H127.759V102.966H131.69V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 99.0345H131.69V102.966H135.621V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 99.0345H135.621V102.966H139.552V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 99.0345H143.483V102.966H147.414V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 99.0345H147.414V102.966H151.345V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 99.0345H167.069V102.966H171V99.0345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 102.966H57V106.897H60.931V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 102.966H68.7931V106.897H72.7241V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 102.966H76.6552V106.897H80.5862V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 102.966H84.5172V106.897H88.4483V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 102.966H88.4483V106.897H92.3793V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 102.966H92.3793V106.897H96.3103V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 102.966H104.172V106.897H108.103V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 102.966H112.034V106.897H115.966V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 102.966H119.897V106.897H123.828V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 102.966H127.759V106.897H131.69V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 102.966H139.552V106.897H143.483V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 102.966H143.483V106.897H147.414V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 102.966H147.414V106.897H151.345V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 102.966H163.138V106.897H167.069V102.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 106.897H60.931V110.828H64.8621V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 106.897H64.8621V110.828H68.7931V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 106.897H72.7241V110.828H76.6552V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 106.897H76.6552V110.828H80.5862V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 106.897H80.5862V110.828H84.5172V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 106.897H84.5172V110.828H88.4483V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 106.897H96.3103V110.828H100.241V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 106.897H100.241V110.828H104.172V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 106.897H108.103V110.828H112.034V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 106.897H112.034V110.828H115.966V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 106.897H115.966V110.828H119.897V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 106.897H119.897V110.828H123.828V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 106.897H123.828V110.828H127.759V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 106.897H127.759V110.828H131.69V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 106.897H135.621V110.828H139.552V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 106.897H139.552V110.828H143.483V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 106.897H151.345V110.828H155.276V106.897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 110.828H57V114.759H60.931V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 110.828H60.931V114.759H64.8621V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 110.828H68.7931V114.759H72.7241V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 110.828H76.6552V114.759H80.5862V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 110.828H84.5172V114.759H88.4483V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 110.828H88.4483V114.759H92.3793V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 110.828H96.3103V114.759H100.241V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 110.828H104.172V114.759H108.103V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 110.828H112.034V114.759H115.966V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 110.828H119.897V114.759H123.828V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 110.828H123.828V114.759H127.759V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 110.828H127.759V114.759H131.69V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 110.828H143.483V114.759H147.414V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 110.828H159.207V114.759H163.138V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 110.828H163.138V114.759H167.069V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 110.828H167.069V114.759H171V110.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 114.759H57V118.69H60.931V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 114.759H60.931V118.69H64.8621V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 114.759H64.8621V118.69H68.7931V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 114.759H68.7931V118.69H72.7241V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 114.759H76.6552V118.69H80.5862V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 114.759H80.5862V118.69H84.5172V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 114.759H84.5172V118.69H88.4483V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 114.759H88.4483V118.69H92.3793V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 114.759H92.3793V118.69H96.3103V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 114.759H96.3103V118.69H100.241V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 114.759H100.241V118.69H104.172V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 114.759H112.034V118.69H115.966V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 114.759H115.966V118.69H119.897V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 114.759H135.621V118.69H139.552V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 114.759H139.552V118.69H143.483V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 114.759H147.414V118.69H151.345V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 114.759H151.345V118.69H155.276V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 114.759H155.276V118.69H159.207V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 114.759H159.207V118.69H163.138V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 114.759H163.138V118.69H167.069V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 114.759H167.069V118.69H171V114.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 118.69H57V122.621H60.931V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 118.69H68.7931V122.621H72.7241V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 118.69H72.7241V122.621H76.6552V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 118.69H76.6552V122.621H80.5862V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 118.69H84.5172V122.621H88.4483V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 118.69H88.4483V122.621H92.3793V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 118.69H92.3793V122.621H96.3103V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 118.69H104.172V122.621H108.103V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 118.69H108.103V122.621H112.034V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 118.69H112.034V122.621H115.966V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 118.69H131.69V122.621H135.621V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 118.69H135.621V122.621H139.552V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 118.69H143.483V122.621H147.414V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 118.69H167.069V122.621H171V118.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 122.621H57V126.552H60.931V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 122.621H64.8621V126.552H68.7931V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 122.621H76.6552V126.552H80.5862V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 122.621H80.5862V126.552H84.5172V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4483 122.621H84.5172V126.552H88.4483V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 122.621H92.3793V126.552H96.3103V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 122.621H96.3103V126.552H100.241V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 122.621H100.241V126.552H104.172V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 122.621H108.103V126.552H112.034V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 122.621H112.034V126.552H115.966V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 122.621H115.966V126.552H119.897V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 122.621H119.897V126.552H123.828V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 122.621H123.828V126.552H127.759V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 122.621H127.759V126.552H131.69V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 122.621H131.69V126.552H135.621V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 122.621H135.621V126.552H139.552V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 122.621H139.552V126.552H143.483V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 122.621H143.483V126.552H147.414V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 122.621H147.414V126.552H151.345V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 122.621H151.345V126.552H155.276V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 122.621H159.207V126.552H163.138V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 122.621H163.138V126.552H167.069V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 122.621H167.069V126.552H171V122.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 126.552H92.3793V130.483H96.3103V126.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 126.552H119.897V130.483H123.828V126.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 126.552H135.621V130.483H139.552V126.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 126.552H151.345V130.483H155.276V126.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 126.552H155.276V130.483H159.207V126.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 126.552H163.138V130.483H167.069V126.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 126.552H167.069V130.483H171V126.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 130.483H57V134.414H60.931V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 130.483H60.931V134.414H64.8621V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 130.483H64.8621V134.414H68.7931V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 130.483H68.7931V134.414H72.7241V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 130.483H72.7241V134.414H76.6552V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 130.483H76.6552V134.414H80.5862V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 130.483H80.5862V134.414H84.5172V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 130.483H88.4483V134.414H92.3793V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 130.483H92.3793V134.414H96.3103V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 130.483H108.103V134.414H112.034V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 130.483H127.759V134.414H131.69V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 130.483H131.69V134.414H135.621V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 130.483H135.621V134.414H139.552V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 130.483H143.483V134.414H147.414V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 130.483H151.345V134.414H155.276V130.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 134.414H57V138.345H60.931V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 134.414H80.5862V138.345H84.5172V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 134.414H92.3793V138.345H96.3103V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 134.414H96.3103V138.345H100.241V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 134.414H100.241V138.345H104.172V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 134.414H108.103V138.345H112.034V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 134.414H112.034V138.345H115.966V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 134.414H115.966V138.345H119.897V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 134.414H123.828V138.345H127.759V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 134.414H127.759V138.345H131.69V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 134.414H135.621V138.345H139.552V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 134.414H151.345V138.345H155.276V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 134.414H159.207V138.345H163.138V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 134.414H163.138V138.345H167.069V134.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 138.345H57V142.276H60.931V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 138.345H64.8621V142.276H68.7931V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 138.345H68.7931V142.276H72.7241V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 138.345H72.7241V142.276H76.6552V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 138.345H80.5862V142.276H84.5172V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 138.345H92.3793V142.276H96.3103V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 138.345H96.3103V142.276H100.241V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 138.345H100.241V142.276H104.172V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 138.345H112.034V142.276H115.966V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 138.345H115.966V142.276H119.897V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 138.345H119.897V142.276H123.828V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 138.345H135.621V142.276H139.552V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 138.345H139.552V142.276H143.483V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 138.345H143.483V142.276H147.414V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 138.345H147.414V142.276H151.345V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 138.345H151.345V142.276H155.276V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 138.345H155.276V142.276H159.207V138.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 142.276H57V146.207H60.931V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 142.276H64.8621V146.207H68.7931V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 142.276H68.7931V146.207H72.7241V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 142.276H72.7241V146.207H76.6552V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 142.276H80.5862V146.207H84.5172V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 142.276H88.4483V146.207H92.3793V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 142.276H104.172V146.207H108.103V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 142.276H119.897V146.207H123.828V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 142.276H123.828V146.207H127.759V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 142.276H135.621V146.207H139.552V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 142.276H139.552V146.207H143.483V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 142.276H143.483V146.207H147.414V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.345 142.276H147.414V146.207H151.345V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 142.276H155.276V146.207H159.207V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 142.276H163.138V146.207H167.069V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 142.276H167.069V146.207H171V142.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 146.207H57V150.138H60.931V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 146.207H64.8621V150.138H68.7931V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 146.207H68.7931V150.138H72.7241V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 146.207H72.7241V150.138H76.6552V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 146.207H80.5862V150.138H84.5172V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 146.207H96.3103V150.138H100.241V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 146.207H104.172V150.138H108.103V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 146.207H108.103V150.138H112.034V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 146.207H112.034V150.138H115.966V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 146.207H123.828V150.138H127.759V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 146.207H127.759V150.138H131.69V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.621 146.207H131.69V150.138H135.621V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.552 146.207H135.621V150.138H139.552V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 146.207H139.552V150.138H143.483V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 146.207H151.345V150.138H155.276V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 146.207H159.207V150.138H163.138V146.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 150.138H57V154.069H60.931V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 150.138H80.5862V154.069H84.5172V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 150.138H88.4483V154.069H92.3793V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.241 150.138H96.3103V154.069H100.241V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 150.138H108.103V154.069H112.034V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 150.138H112.034V154.069H115.966V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.897 150.138H115.966V154.069H119.897V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.828 150.138H119.897V154.069H123.828V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 150.138H123.828V154.069H127.759V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 150.138H139.552V154.069H143.483V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.414 150.138H143.483V154.069H147.414V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 150.138H151.345V154.069H155.276V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.207 150.138H155.276V154.069H159.207V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.069 150.138H163.138V154.069H167.069V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 150.138H167.069V154.069H171V150.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.931 154.069H57V158H60.931V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 154.069H60.931V158H64.8621V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7931 154.069H64.8621V158H68.7931V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7241 154.069H68.7931V158H72.7241V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6552 154.069H72.7241V158H76.6552V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 154.069H76.6552V158H80.5862V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5172 154.069H80.5862V158H84.5172V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3793 154.069H88.4483V158H92.3793V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3103 154.069H92.3793V158H96.3103V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.172 154.069H100.241V158H104.172V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.034 154.069H108.103V158H112.034V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966 154.069H112.034V158H115.966V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.483 154.069H139.552V158H143.483V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.276 154.069H151.345V158H155.276V154.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.138 154.069H159.207V158H163.138V154.069Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_397_6404",
    x: 0,
    y: 0,
    width: 228,
    height: 228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_6404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_6404",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.2acc8f8f276f65ff509dc0e4f629f781.svg";
export { ForwardRef as ReactComponent };